import {ON_CART_UPDATE} from "../apps/globals";

export default () => {

    window.addEventListener(ON_CART_UPDATE, (e) => {
        const dom = document.querySelector('.abandoned-order');
        if (e.data.items > 0 && dom) {
            dom.remove();
        }
    })

}
